export interface ErrorInfo {
  message: string
  statusCode: number | null
  isAuthError: boolean
  isPageError: boolean
}

export function analyzeError(err: any): ErrorInfo {
  const errorMessage = err instanceof Error ? err.message : 'Unknown error occurred'
  const statusCode = err.statusCode || err.status || null

  // 檢查是否為授權相關錯誤
  const isAuthError = statusCode === 401 || statusCode === 403 ||
    (err instanceof Error && (
      err.message.includes('No access token') ||
      err.message.includes('Invalid token') ||
      err.message.includes('Token expired') ||
      err.message.includes('Unauthorized') ||
      err.message.includes('Forbidden')
    ))

  // 檢查是否為頁面級錯誤
  const isPageError = isAuthError ||
    statusCode >= 500 ||
    statusCode === 404 ||
    (err instanceof Error && (
      err.message.includes('Network') ||
      err.message.includes('Failed to fetch')
    ))

  // 簡化錯誤訊息
  let simplifiedMessage = errorMessage
  if (statusCode === 404) {
    simplifiedMessage = 'Resource not found'
  } else if (statusCode === 500) {
    simplifiedMessage = 'Server error'
  } else if (statusCode === 401) {
    simplifiedMessage = 'Authentication required'
  } else if (statusCode === 403) {
    simplifiedMessage = 'Access denied'
  } else if (errorMessage.includes('HTTP error! status:')) {
    simplifiedMessage = `Error ${statusCode}`
  }

  return {
    message: simplifiedMessage,
    statusCode: isAuthError ? (statusCode || 401) : statusCode,
    isAuthError,
    isPageError
  }
}